function base64UrlToUtf8(segment: string): string {
  const padded = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (4 - (padded.length % 4)) % 4;
  const base64 = padded + '='.repeat(padLength);
  return globalThis.atob(base64);
}

function parseJwtPayload(token: string): Record<string, unknown> | null {
  if (!token || !token.includes('.')) {
    return null;
  }
  try {
    const payloadSegment = token.split('.')[1];
    if (!payloadSegment) return null;
    return JSON.parse(base64UrlToUtf8(payloadSegment)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  if (typeof window === 'undefined' || !token) {
    return true;
  }
  const payload = parseJwtPayload(token);
  if (!payload) return true;
  const exp = payload['exp'];
  if (typeof exp !== 'number') return true;
  const expires = new Date(exp * 1000);
  return expires <= new Date();
}
